// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"placeholder___31hK2","r50":"r50___2H60M","r56":"r56___2Bwv4","r100":"r100___2zAHu"};